import React, { Component } from 'react';


type TaxpayerPortalPanelProps = {
    className?: string | null;
    headerClassName?: string | null;
    header: string;
}

export default class TablePanel extends Component<TaxpayerPortalPanelProps> {
    render() {
        const providedClass = this.props.className ? ` ${this.props.className}` : "";
        return (
            <div className={`panel summary-panel${providedClass}`}>
                <div className={`panel-heading ${` ${this.props.headerClassName}`}`}>{this.props.header}</div>
                {this.props.children}
            </div>
        );
    }
}